<script>
  import _ from 'lodash'
  import moment from 'moment'
  import TimeUtils from '@/utils/time'
  import RecordService from '@/request/record/record'
  // import PatientService from '@/request/patient/patient'
  import FollowupService from '@/request/followup/followup'
  import TempFollowupPlanService from '@/request/template/FollowupPlan'
  import FollowupEdit from './followup-edit'
  export default {
    name: 'FollowupListEdit',
    components: {
      FollowupEdit
    },
    props: {
      rids: {
        type: String,
        default: null
      },
      listStyle: Object,
      showButtons: {
        type: Boolean,
        default: true
      }
    },
    data () {
      return {
        list: [],
        records: [],
        patient: {},
        followup: {startTime: moment().startOf('day').valueOf()},
        waitListSave: {},
        saving: false,
        tempFollowupDiloagVisible: false
      }
    },
    computed: {},
    created: function () {
      this.loadRecord()
      this.listFollowup()
      // this.loadPatient()
      // this.initPinfo()
    },
    watch: {
      rids () {
        this.loadRecord()
        this.listFollowup()
      },
      /*record () {
          this.loadPatient()
      },*/
      waitListSave () {
        this.checkDone()
      }
    },
    methods: {
      loadRecord () {
        this.records = []
        if (!this.rids) {
          return
        }
        RecordService.list({
          ids: this.rids
        }).then(res => {
          this.records = res.result || []
          if (this.records.length === 1) {
            this.initPinfo(this.records[0])
          }
        }).catch(error => {
          this.$message.error(error || '病历不存在或已被删除')
          this.handleCancle()
        })
      },
      /*loadPatient () {
          this.patient = {}
          if (_.isEmpty(this.record) || !this.record.pat) {
              return
          }
          PatientService.load({
              id: this.record.pat
          }).then(data => {
              if (data.result) {
                  this.patient = _.cloneDeep(data.result)
                  this.initPinfo()
              }
          })
      },*/
      listFollowup () {
        this.list = []
        if (!this.rids) {
          return
        }
        if (this.rids.split(',').length > 1) {
          return;
        }
        FollowupService.list({
          diseaseRecordId: this.rids
        }).then(data => {
          this.list = data ? _.sortBy(data.result, [function (o) { return o.num }]) : []
          if (!_.isEmpty(this.list)) {
            this.initPinfo()
          }
        })
      },
      initPinfo (record) {
        if (!record) {
          record = {}
        }
        let at = _.isEmpty(this.list) ? {} : this.list[0]
        // console.log('init p info at:' + JSON.stringify(at))
        let comm = {}
        comm.patId = at.patId || record.pat || null
        comm.name = at.name || record.patName || null
        comm.sex = at.sex || record.sex || 1
        comm.age = (at.age || record.age || null)
        if (this.records.length > 1) {
          comm.mobile = record.mobile || null
        } else {
          comm.mobile = (at.mobile || record.mobile || null)
        }
        comm.address = at.address || record.address || null
        comm.diseaseRecordId = at.diseaseRecordId || record.id || null
        comm.historySn = at.historySn || record.historySn || null
        // comm.startTime = at.startTime || this.record.arrangedStartTime || moment().startOf('day').valueOf()
        comm.startTime = at.startTime || this.recordTime() || moment().startOf('day').valueOf()
        this.followup = _.clone(comm)
      },
      recordTime (record) {
        if (!record) {
          return null
        }
        if (!record.hospitalized) {
          return record.createTime
        }
        return record.arrangedStartTime || record.leaveTime || record.admissionDate
      },
      sort () {
        if (_.isEmpty(this.list)) return
        this.list = _.sortBy(this.list, 'time')
        for (let i = 0; i < this.list.length; i++) {
          let item = this.list[i]
          if (item.num === (i + 1)) {
            continue
          }
          item.num = i + 1
          this.$set(this.list, i, _.clone(item))
        }
      },
      addFollowup () {
        let at = _.isEmpty(this.list) ? {} : this.list[this.list.length - 1]
        let fu = _.defaultsDeep({
          time: at.time || moment(this.followup.startTime).add(1, 'd').startOf('day').add(9, 'h').valueOf(),
          num: at.num ? at.num + 1 : 1
        }, this.followup)
        this.list.push(fu)
        this.sort()
      },
      showTemplate () {
        this.tempFollowupDiloagVisible = true
      },
      handleSelectedFollowupTemp (fid) {
        this.list = []
        if (!fid) {
          this.tempFollowupDiloagVisible = false
          return
        }
        TempFollowupPlanService.list({
          fid: fid
        }).then(res => {
          let data = _.clone(res.result || [])
          let start = this.followup.startTime || moment(0).startOf('day')
          let plans = []
          let i = 0
          _.forEach(data, item => {
            plans.push({
              time: TimeUtils.durationToTime(start, item.duration) - (8 * 60 * 60 * 1000),
              label: item.label,
              inquiry: item.inquiry,
              num: ++i
            })
          })
          this.list = _.clone(plans)
          this.tempFollowupDiloagVisible = false
        })
      },
      handleDeleteFollowup (item) {
        let index = _.indexOf(this.list, item)
        if (index < 0) {
          return
        }
        this.list.splice(index, 1)
      },
      handleSaveDone (followup, item, index) {
        index = (_.isUndefined(index) || _.isNull(index)) ? -1 : index
        if (index < 0 && item) {
          index = _.indexOf(this.list, item)
        }
        if (index >= 0) {
          let _wait = this.waitListSave
          delete _wait[index]
          this.waitListSave = _.cloneDeep(_wait)
          if (!_.isEmpty(followup)) {
            this.$set(this.list, index, followup)
          }
        } else if (!_.isEmpty(followup)) {
          this.list.push(followup)
        }
      },
      handleCancle () {
        this.saving = false
        this.waitListSave = {}
        this.$emit('cancle')
      },
      checkDone () {
        if (!this.saving) {
          return
        }
        if (!_.isEmpty(this.waitListSave)) {
          return
        }
        this.listFollowup()
        this.saving = false
        this.$message({
          message: '保存随访计划成功',
          type: 'success'
        })
        this.$emit('saveDone')
      },
      save () {
        this.waitListSave = {}
        _.forEach(this.list, (item, index) => {
          this.waitListSave[index] = true
          this.$refs['followup-edit-items'][index].save(index)
        })
        this.saving = true
      }
    }
  }
</script>

<template>
  <div>
    <div v-if="records.length > 1" >
      <p style="text-align: center; font-size: 24px; margin-bottom: 20px"><span>正在为</span><span style="color: #dd1144">{{records.length}}位患者</span><span>制定随访计划</span></p>
    </div>
    <div v-if="records.length === 1" class="record-info box" v-for="(record, index) in records" :key="index">
      <el-row :gutter="20">
        <el-col :span="8">
          <span>姓名：{{record.patName}}</span>
        </el-col>
        <el-col :span="8">
          <span>性别：{{!!record.sex && record.sex % 2 === 0 ? '女' : '男'}}</span>
        </el-col>
        <el-col :span="8">
          <span>年龄：{{record.age || '未知'}}岁</span>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="8">
          <span>主治医生：{{record.attendingName || '无'}}</span>
        </el-col>
        <el-col :span="8">
          <span>科室：{{record.orgName}}({{record.hname}})</span>
        </el-col>
        <el-col :span="8">
          <span>诊断：{{record.diagnoseNames || '无'}}</span>
        </el-col>
      </el-row>
    </div>
    <el-form ref="form" label-position="right" label-width="100px" :model="followup" :disabled="saving" inline :style="{textAlign: (records.length > 1 ? 'center' : '')}">
      <el-form-item label="开始时间" prop="startTime" style="margin-right: 0;" :style="{width: (records.length > 1 ? '100%' : '50%')}">
        <el-date-picker
          style="width: 200px"
          v-model="followup.startTime"
          type="date"
          placeholder="选择日期"
          format="yyyy年MM月dd日"
          value-format="timestamp"
          :clearable="false"
        ></el-date-picker>
      </el-form-item>
      <el-form-item label="患者手机号" prop="mobile" style="width: 50%; margin-right: 0;" v-if="records.length === 1">
        <el-input v-model="followup.mobile" style="width: 200px" placeholder="请输入手机号用于随访时联系患者" :rules="[{ required: true, message: '手机号不能为空' }]"></el-input>
      </el-form-item>
    </el-form>
    <div class="followup-list flex-disply" :style="listStyle">
      <el-scrollbar class="flex-scrollbar" wrap-class="default-scrollbar__wrap" view-class="default-scrollbar__view">
        <followup-edit
          v-for="(item, index) in list"
          ref="followup-edit-items"
          :data="item"
          :records="records"
          :common="followup"
          :key="index"
          @remove="handleDeleteFollowup"
          @saveDone="handleSaveDone"
        ></followup-edit>
        <div class="add-followup-btn">
          <el-button type="text" @click="addFollowup">添加随访计划</el-button>
          <el-button type="text" @click="showTemplate" v-if="list.length === 0">去随访模板选择</el-button>
        </div>
      </el-scrollbar>
    </div>
    <el-form ref="formButtons" :disabled="saving" v-if="showButtons">
      <el-form-item>
        <el-button type="primary" @click="save">确定</el-button>
        <el-button @click="handleCancle">取消</el-button>
      </el-form-item>
    </el-form>
    <el-dialog title="随访模板" :visible.sync="tempFollowupDiloagVisible" append-to-body>
      <temp-followup-list-selection @selected="handleSelectedFollowupTemp" @cancle="tempFollowupDiloagVisible = false"></temp-followup-list-selection>
    </el-dialog>
  </div>
</template>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .box {
    padding: 20px 20px 0 20px;
    background: #F2F6FC;
    border-radius: 4px;
    border: 1px solid #DCDFE6;
    margin-bottom: 10px;
  }
  .box.record-info {
    padding: 20px;
    margin-bottom: 20px;
  }
  .record-info span {
    width: 100%;
    word-break: break-all;
    text-overflow: ellipsis;
    display: -webkit-box; /** 对象作为伸缩盒子模型显示 **/
    -webkit-box-orient: vertical; /** 设置或检索伸缩盒对象的子元素的排列方式 **/
    -webkit-line-clamp: 2; /** 显示的行数 **/
    overflow: hidden;  /** 隐藏超出的内容 **/
  }
  .followup-list {
    min-height: 320px;
    max-height: 420px;
    padding: 10px 0;
    box-sizing: border-box;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    -o-box-sizing: border-box;
    -ms-box-sizing: border-box;
  }
  .add-followup-btn {
    text-align: center;
  }
</style>
